import styled from '@emotion/styled';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { fontSize } from 'presentations/views/styles';
import { white } from 'presentations/views/styles/color';

interface Props {
  children?: any;
  title?: string | null;
  onClose?: any;
  className?: string;
  placement?: 'top' | 'bottom' | 'right';
}

export default function Component(props: Props) {
  if (!props.title) return props.children;
  return (
    <StyledTooltip
      className={props.className}
      // open={props.isOpen}
      title={props.title}
      aria-label={props.title}
      placement={props.placement || 'bottom'}
      arrow={true}
      disableFocusListener
      // disableHoverListener
      disableTouchListener
      onClose={props.onClose}
    >
      <span>{props.children}</span>
    </StyledTooltip>
  );
}

const StyledTooltip = styled(Tooltip)`
  /* &.${tooltipClasses.tooltip} {
    font-size: ${fontSize(18)} !important;
    background-color: ${white} !important;
  } */
`;
